<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;" style="margin-bottom: 10px">
      <el-row :gutter="15">
        <el-col :md="4" style="margin-bottom: 15px">
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expand-all="true"
              @node-click="choose"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="20" style="margin-bottom: 15px">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>检查单管理</span>
            </div>
            <div>
              <el-tabs v-model="active" class="top-card-tabs">
                <el-tab-pane label="每日一览" name="dayRecord">
                  <dayRecord ref="dayRecord" />
                </el-tab-pane>
                <el-tab-pane label="统计导出" name="totalRecord">
                  <totalRecord ref="totalRecord" />
                </el-tab-pane>
                <el-tab-pane label="检查单统计" name="checkRecord">
                  <checkRecord ref="checkRecord" />
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import dayRecord from './checkFormManage/dayRecord';
  import totalRecord from './checkFormManage/totalRecord';
  import checkRecord from './checkFormManage/checkRecord';
  import { getAllGradeTree } from '@/config/api';
  export default {
    name: 'CheckFormManage',
    components: { dayRecord, totalRecord, checkRecord },
    data() {
      return {
        active: 'dayRecord',
        loading: true, // 加载状态
        deptData: [], // 列表数据
      };
    },
    mounted() {
      this.getOrgList();
    },
    methods: {
      // 获取学校班级树
      getOrgList() {
        this.loading = true;
        getAllGradeTree()
          .then((res) => {
            this.loading = false;
            if (res.data.resCode == 200) {
              this.deptData.push(res.data.data);
              setTimeout(() => {
                this.choose(this.deptData[0].children[0].children[0]);
              }, 100);
            } else {
              this.$message.error(res.data.data.resMsg || '获取数据失败');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      },
      /* 选择数据 */
      choose(row) {
        if (row.orgType === 3) {
          this.$refs.orgTree.setCurrentKey(row.id);
          this.$refs.dayRecord.gradeId = row.id.slice(1);
          this.$refs.dayRecord.getDayData();
          this.$refs.totalRecord.gradeId = row.id.slice(1);
          this.$refs.totalRecord.getTotalData();
          this.$refs.checkRecord.gradeId = row.id.slice(1);
          this.$refs.checkRecord.table.where.gradeId = row.id.slice(1);
          this.$refs.checkRecord.$refs.table.reload();
          this.$refs.checkRecord.getClassList(row.id.slice(1));
          this.$refs.checkRecord.getFirst();
        } else {
          this.$message.info('请选择年级');
        }
      },
    },
  };
</script>

<style scoped>
  .top-card-tabs >>> .el-tabs__nav-wrap:after {
    display: none;
  }

  .top-card-tabs {
    margin-left: 5px;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
  .box-card {
    height: calc(100vh - 150px);
  }
</style>
